import React from 'react';
import { TableBodyProps } from './types';
import './styles.css';

const TableBody: React.FC<TableBodyProps> = ({ children }) => {
  return <tbody className="mt-[42px] bg-white">{children}</tbody>;
};

export { TableBody };
